// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

import { useEffect } from 'react'

/**
 * useUnsavedChangesGuard — while `dirty`, closing or reloading the tab asks the browser's
 * "Leave site?" prompt first. In-app navigation (a Back button) is the caller's to confirm with
 * ConfirmDialog; the browser cannot see it.
 */
export function useUnsavedChangesGuard(dirty: boolean): void {
  useEffect(() => {
    if (!dirty) return
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault()
      e.returnValue = ''   // still required by Chrome/Edge to show the prompt
    }
    window.addEventListener('beforeunload', onBeforeUnload)
    return () => window.removeEventListener('beforeunload', onBeforeUnload)
  }, [dirty])
}
